
/* injects from baggage-loader */

'use strict';

import './header.scss';
import headerDirective from './header.directive';
import headerFactory from './header.factory';
/**
 * Header module definition.
 */
const headerModule = angular.module('header.module', []);

headerModule
	.directive('appHeader', headerDirective)
	.factory('headerFactory', headerFactory);

export default headerModule;



// WEBPACK FOOTER //
// ./src/app/core/components/header/header.module.js